module.exports = __webpack_public_path__ + "img/icon-camera.6e9a77db.png";